export class Alergy {

  alergyID: number;
  patientID: number;

  remarks: string;
  status: number;
  alergyTypeID: number;

  createdAt: Date;
  createdBy: number;
  modifiedAt: Date;
  modifiedBy: number;
}
